import { xcoverAPI } from '..';
import { IClaimDetailsListShape, IClaimDetails, IFeedbackStatus, IFeedbackPayload } from '../../../../helpers/types';

export const claimsAPI = xcoverAPI.injectEndpoints({
  endpoints: (builder) => ({
    getCustomerClaimsList: builder.query<IClaimDetailsListShape[], { id: string; locale: string }>({
      query: ({ id, locale }) => {
        const searchParams = new URLSearchParams({
          language: locale,
        });
        return `customers/${id}/claims/?${searchParams}`;
      },
    }),
    getFeedback: builder.query<IFeedbackStatus | null, { claimReference?: string | string[] }>({
      query: ({ claimReference }) => `claims/${claimReference}/feedback/`,
    }),
    submitFeedback: builder.mutation<
      void,
      { body: IFeedbackPayload; securityToken: string | null; claimReference?: string | string[] }
    >({
      query: ({ claimReference, securityToken, body }) => ({
        url: `claims/${claimReference}/feedback/?security_token=${securityToken}`,
        method: 'POST',
        body,
      }),
    }),
    getClaimDetailsView: builder.query<IClaimDetails, { claimReference: string; locale: string }>({
      query: ({ claimReference, locale }) => {
        const searchParams = new URLSearchParams({
          language: locale,
          // This will always return the details view shape of the claim
          // It's not easy to use generic type in the params to infer the shape of the response
          // To get the simple view shape create a new endpoint
          view: 'details',
        });
        return `claims/${claimReference}/?${searchParams}`;
      },
    }),
  }),
  overrideExisting: false,
});
